var _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 330 320",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#efb0ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.3692 131.13877c-1.11288-1.3781-2.8014-2.14371-4.60506-2.14371H75.57828c-.30697 0-.57561-.11483-.80587-.30623-.19188-.1914-.30701-.42109-.30701-.68905v-24.99707c0-.26797.11513-.49764.30701-.68904.23026-.22969.4989-.34453.80587-.30625h39.29653c9.90084 0 18.45859 4.05772 25.67321 12.13487l9.55545 11.63723-18.6121 22.62368-14.12217-17.26443zm68.69214-17.11132c7.17619-8.00059 15.77232-12.02003 25.78829-12.02003h39.18141c.26859-.03828.53722.07656.72911.22968.19188.19141.26863.45937.23026.76561v24.99707c0 .26796-.07676.49765-.23026.68905-.19189.22967-.46052.34452-.72911.30623h-37.18587c-1.76528-.03828-3.4538.76561-4.60506 2.14371L181.84 164.40438l27.51524 33.49531c1.11288 1.26324 2.76303 2.02885 4.45155 1.99058h37.18587c.26864-.03828.5756.11484.72911.30624.15351.22969.26864.53593.23026.80389v24.99708c0 .26793-.07675.49763-.23026.68904-.19184.22967-.46047.3445-.72911.30623h-39.14303c-10.01597 0-18.53535-4.05771-25.67316-12.13487l-22.79506-27.75325-22.79506 27.75325c-7.17619 8.07716-15.77232 12.13487-25.78829 12.13487H75.57828c-.2686.03827-.57561-.11483-.72911-.30623-.19189-.2297-.26864-.53594-.23026-.80391v-24.99706c0-.26796.07675-.49763.23026-.68904.19188-.22968.46051-.34452.72911-.30624h37.18586c1.76528 0 3.45381-.80389 4.60506-2.1437l26.90121-32.76798 41.79093-50.95114z",
    strokeLinejoin: "miter",
    fillRule: "nonzero",
    strokeWidth: 8,
    fill: "#a440f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 162,
    strokeWidth: 24,
    r: 150,
    fill: "none"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 162,
    fill: "none",
    stroke: "#a440f2",
    strokeWidth: 10,
    r: 150
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnx);
export default __webpack_public_path__ + "static/media/snx.9cd68e8dcd1dde6884ec61adc184db7f.svg";
export { ForwardRef as ReactComponent };